// extracted by mini-css-extract-plugin
export default {"transliterBox":"style_transliterBox__5X37G","inputBox":"style_inputBox__dgCBw"};